export const getBearerTokenHeader = (keycloak) => {
    const accessToken = keycloak?.token;
    if (!accessToken) {
        return {};
    }
    return {
        Authorization: `Bearer ${accessToken}`
    };
};
//# sourceMappingURL=getBearerTokenHeader.js.map